import React from "react";
import PropTypes from "prop-types";
import {
  IF_ERROR_PERSISTS_CONTACT_HELP_DESK_MESSAGE,
  IF_ERROR_PERSISTS_CONTACT_HELP_DESK_WITH_ERROR_REFERENCE_ID_MESSAGE,
} from "../util/messageConstants";
import { sendClientErrorToServer } from "../api/system";
import { useEffect } from "react";
import { isSessionCookieActive } from "../util/authentication";
import { Box } from "@mui/material";

const ErrorMessage = (props) => {
  useEffect(() => {
    let payload = {}
    if (!!props.errorPayload) {
      payload = props.errorPayload;
    } else {
      payload = {
        client: "See SWA-STARS-IDToken",
        error: "NA",
        // Very strange AWS API Gateway issue occurs if `localhost` exists in the payload...
        error_info: props.errorMessage,
        service: "stars-trade-form-client-module",
        error_code: props.errorCode,
        session_data: window.localStorage,
        rrn: props.errorReferenceId ? props.errorReferenceId : "NA",
      };
    }

    if (isSessionCookieActive()) {
      sendClientErrorToServer(payload);
    }
  }, [props.errorCode, props.errorMessage, props.errorReferenceId, props.errorPayload]);
  return (
    <Box data-testid="error-message" className={props.className} sx={props.sx}>
      <div className="page-error">
        <div className="error-message">{props.errorMessage}</div>
        <div className="error-message">Error Code: {props.errorCode}</div>
        {props.errorReferenceId ? (
          <div className="error-message">Error Reference ID: {props.errorReferenceId}</div>
        ) : (
          ""
        )}
        <div>
          {props.errorReferenceId
            ? IF_ERROR_PERSISTS_CONTACT_HELP_DESK_WITH_ERROR_REFERENCE_ID_MESSAGE
            : IF_ERROR_PERSISTS_CONTACT_HELP_DESK_MESSAGE}
        </div>
      </div>
    </Box>
  );
};

ErrorMessage.propTypes = {
  className: PropTypes.string,
  sx: PropTypes.string,
  errorMessage: PropTypes.string,
  errorCode: PropTypes.string,
  errorReferenceId: PropTypes.string,
};

export default ErrorMessage;
